import { Redirect } from 'react-router-dom';

import { isConcierge, isPM, isService, isStaffRole } from '../utils';

export const getHomeRoute = (user) => {
  if (isService()) return <Redirect to="/call-center-dashboard" />;
  if (!user) return <Redirect to="/logout" />;

  // if has PMC
  const pmcId = user?.pmcRole?.[0]?.propertyId;
  if (isPM() && pmcId) {
    return <Redirect to={`/pmc/${pmcId}/all-doors-and-cameras`} />;
  }

  // if has Building
  const buildingId = user?.properties?.[0]?.id;
  const isStaffBuilding =
    !user?.pmcRoles?.length &&
    user?.properties?.length === 1 &&
    user?.properties[0]?.roles?.some((role) => isStaffRole(role));
  const isConciergeSingle = isConcierge() && user?.properties?.length === 1;
  const frontDeskEnabled =
    isConciergeSingle && user?.properties?.[0]?.frontDeskEnabledFlag;
  const tabUrl = frontDeskEnabled
    ? `front-desk`
    : isConciergeSingle
    ? `all-doors-and-cameras`
    : isStaffBuilding
    ? `staff`
    : null;
  if (tabUrl) {
    return buildingId ? (
      <Redirect to={`/building/${buildingId}/${tabUrl}`} />
    ) : (
      <Redirect to="/buildings" />
    );
  }

  return <Redirect to="/buildings" />;
};
